import SplitMapContext from 'context/split-map-context'

export default function useSplitMap(splitRef = 'split') {
  // Read once, unconditionally, so the hook order stays stable when splitRef
  // varies between renders.
  const splitMapContext = React.useContext(SplitMapContext)

  if (splitRef === 'split') {
    return splitMapContext
  } else if (splitRef === 'lock_a') {
    const { lock_a, onSwitchLockA } = splitMapContext
    return { lock: lock_a, onSwitchLock: onSwitchLockA }
  } else if (splitRef === 'lock_b') {
    const { lock_b, onSwitchLockB } = splitMapContext
    return { lock: lock_b, onSwitchLock: onSwitchLockB }
  }
}
